import type { Component } from 'solid-js'

import { patternSpecificationList } from '@hvf/contracts'
import { useService } from 'solid-services'
import { useFilters, type PatternSpecFilterType } from '../state/filter'
import { FilterSelect } from './FilterSelect'

// Define the FE label for null values
const NULL_LABEL = 'Unspecified'

export const PatternSpecification: Component = () => {
  const { filters, setPatternSpecification } = useService(useFilters)()

  // 1. Pass purely strings to the FilterSelect component
  const items = [...patternSpecificationList, NULL_LABEL]

  // 2. Translate the FE strings back into your state types (restoring null)
  const handleChange = (values: string[]) => {
    const mappedValues = values.map((val) =>
      val === NULL_LABEL ? null : (val as PatternSpecFilterType)
    )
    setPatternSpecification(mappedValues)
  }

  return (
    <FilterSelect
      label="Pattern Specification"
      items={items}
      // 3. Translate the state nulls into FE strings for the UI
      // Doing this inline ensures SolidJS tracks it reactively
      selected={filters().patternSpecification.map((val) =>
        val === null ? NULL_LABEL : val
      )}
      onChange={handleChange}
    />
  )
}
